<button class="o-btn"
        [ngClass]="{'is-loading' : !!isLoading$ && (isLoading$ | async),
          'o-btn--ghost' : isGhost,
          'o-btn--small' : size ==='SMALL',
          'o-btn--primary' : flavor === ButtonFlavor.PRIMARY,
          'o-btn--secondary' : flavor === ButtonFlavor.SECONDARY,
          'o-btn--positive' : flavor === ButtonFlavor.POSITIVE,
          'o-btn--negative' : flavor === ButtonFlavor.NEGATIVE}"
        [type]=type
        (click)="buttonClickHandler($event)"
        [disabled]="(isDisabled$ | async)"
        [attr.form]="formName"
>
  <ng-content></ng-content>
</button>
